import React from 'react'
import { SvgIcon } from '@mui/material'

export const BookmarkFillIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M16 2H8a3 3 0 0 0-3 3v16a1 1 0 0 0 1.5.87l5.5-3.18 5.5 3.18a1 1 0 0 0 .5.13 1 1 0 0 0 .5-.13A1 1 0 0 0 19 21V5a3 3 0 0 0-3-3Zm1 17.27-4.5-2.6a1 1 0 0 0-1 0L7 19.27V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v14.27Z"
      fill="inherit"
    />
    <path
      d="m17 19.27-4.5-2.6a1 1 0 0 0-1 0L7 19.27V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v14.27Z"
      fill="inherit"
    />
  </SvgIcon>
)
